import { gsap } from 'gsap';

const container = document.querySelector('.js-filter');

// get filter targets
let targetsArr;
const getFilterTargets = () => (
    Array.isArray(targetsArr)
        ? targetsArr
        : [...document.querySelectorAll('.js-filter-target')]
);

// get select input
let selectInput;
const getSelectInput = () => selectInput || container.querySelector('select');

let selectedFilter;

const refine = (filterBy) => {
    const filterTargets = getFilterTargets();
    const select = getSelectInput();

    // show all filter targets
    if (selectedFilter === filterBy || filterBy === '') {
        selectedFilter = '';
        select.value = '';
        filterTargets.forEach((product) => {
            gsap.set(product, {
                display: 'flex',
            });
        });
        return;
    }

    // filter by
    selectedFilter = filterBy;

    filterTargets.forEach((target) => {
        if (
            target.dataset.labels !== undefined
            && JSON.parse(target.dataset.labels).includes(filterBy)
        ) {
            gsap.set(target, {
                display: 'flex',
            });
        } else {
            gsap.set(target, {
                display: 'none',
            });
        }
    });

    select.value = filterBy;
};

const init = () => {
    if (!container) return;

    const select = getSelectInput();
    if (select) {
        select.addEventListener('change', (event) => {
            event.preventDefault();
            refine(select.value);
        });
    }

    const filterTargets = getFilterTargets();
    filterTargets.forEach((target) => {
        target.addEventListener('mouseenter', () => {
            gsap.to(target, {
                duration: 0.2,
                boxShadow: `inset 0 0 0 4px ${target.dataset.color}`,
                borderColor: target.dataset.color,
                ease: 'power2.out',
            });
        });

        target.addEventListener('mouseleave', () => {
            gsap.to(target, {
                duration: 0.2,
                boxShadow: 'none',
                borderColor: '#bcbcbc',
                ease: 'power2.out',
            });
        });
    });
};

export default init;
